export default __webpack_public_path__ + "static/media/kitchen5-afterC-1920w.7ea95824.png";